import Store from 'redux/store';
import {
  FETCH_REDEMPTION,
  FETCH_REDEMPTION_FAIL,
  FETCH_REDEMPTION_SUCCESS,
} from 'redux/Reducers/ViewRedemption/ViewRedemptionReducer';
import { redemptionEndpoint } from '../clients';

/* eslint-disable */
const FetchRedemption = async (User, finallyCallback = () => { }, { redemptionId }) => {
  Store.dispatch({ type: FETCH_REDEMPTION });
  redemptionEndpoint(User).get(`/${redemptionId}`).then((response) => {
    Store.dispatch({
      type: FETCH_REDEMPTION_SUCCESS,
      payload: {
        data: { ...response.data }
      },
    });
  }).catch((e) => {
    Store.dispatch({
      type: FETCH_REDEMPTION_FAIL, error: e,
    });
  })
    .finally(() => {
      finallyCallback();
    });
};

export default FetchRedemption;